import React, {useEffect, useState} from 'react'
import ModalForm from "../../../../components/modalComponents/ModalForm";
import {Div} from "../../../registroMaternidad/modales/components/Components";
import InputText from "../../../../components/modalComponents/InputText";
import {TableBeneficiosToSolicitarSummary} from "../crearSolicitudBeneficio/components/StyledComponents";
import {useManagePostRequest} from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import {
    actualizarNumeroWhatsAppSolicitudAPI,
    aprobarSolicitudBeneficioAPI,
    getSolicitudBeneficioByIdAPI,
} from "../../../../consumers/backendApisUrls";
import ModalEnabled from "../../../../components/modalComponents/ModalEnabled";
import RechazarSolicitudBeneficio from "./RechazarSolicitudBeneficio";

const VerDetalleSolicitudBeneficio = ({toggleModal, refreshPage, row = {}, isAdmin = false}) => {
    const [executeManagePost] = useManagePostRequest();

    const [responseData, setResponseData] = useState({});
    const [modalEnabled, setModalEnabled] = useState({isEnable: false});
    const [isSending, setIsSending] = useState(false);
    const [numeroWhatsApp, setNumeroWhatsApp] = useState('');
    const [isSavingWhatsApp, setIsSavingWhatsApp] = useState(false);

    useEffect(() => {
        getInitialData();
    }, []);

    const getInitialData = async () => {
        const api = getSolicitudBeneficioByIdAPI(row.IdSolicitudBeneficio);
        await executeManagePost(api, {}, successGetInitialDataCallback);
    }

    const successGetInitialDataCallback = ({data}) => {
        setResponseData(data);
        setNumeroWhatsApp(data?.NumeroWhatsApp ?? '');
    }

    const handleWhatsAppChange = (e) => {
        setNumeroWhatsApp((e.target.value ?? '').replace(/\D/g, '').slice(0, 9));
    }

    const handleGuardarWhatsApp = async (e) => {
        if (e) e.preventDefault();
        if (isSavingWhatsApp || !/^\d{9}$/.test(numeroWhatsApp)) return;
        setIsSavingWhatsApp(true);

        const api = actualizarNumeroWhatsAppSolicitudAPI();
        const payload = {
            IdSolicitudBeneficio: responseData?.IdSolicitudBeneficio,
            NumeroWhatsApp: numeroWhatsApp
        };

        await executeManagePost(api, payload, getInitialData);

        setIsSavingWhatsApp(false);
    }

    const handleApprove = async (e) => {
        setIsSending(true);
        e.preventDefault();

        const api = aprobarSolicitudBeneficioAPI();
        const payload = {
            IdSolicitudBeneficio: responseData?.IdSolicitudBeneficio
        };

        await executeManagePost(api, payload, successAprobarCallBack);

        setIsSending(false);
    }

    const successAprobarCallBack = () => {
        toggleModal();
        refreshPage();
    };

    return (
        <ModalForm titulo="Ver Detalle" width="1100px" showModal={toggleModal} hasSaveButton={false}
                   onSubmit={responseData?.PuedeEditarNumeroWhatsApp ? handleGuardarWhatsApp : undefined}>
            <ModalEnabled modalEnabled={modalEnabled} setModalEnabled={setModalEnabled} toggleParent={toggleModal}
                          refreshPage={refreshPage}/>
            <div className="displayFlexWrap">
                <Div>
                    <InputText
                        name="Campaña"
                        label="Campaña"
                        value={responseData?.Campana}
                        placeholder=""
                        isDisabled
                    />
                </Div>

                <Div>
                    <InputText
                        name="Fecha"
                        label="Fecha Registro"
                        value={responseData?.FechaRegistro}
                        placeholder=""
                        isDisabled
                    />

                </Div>

                <Div>
                    <InputText
                        name="NombreEmpleado"
                        label="Empleado"
                        value={responseData?.NombreEmpleado}
                        placeholder=""
                        isDisabled
                    />
                </Div>

                <Div>
                    <InputText
                        name="Sede"
                        label="Sede"
                        value={responseData?.Sede}
                        placeholder=""
                        isDisabled
                    />
                </Div>

                <Div>
                    <InputText
                        name="Cuotas"
                        label="Cuotas"
                        value={responseData?.CuotasPago}
                        placeholder=""
                        isDisabled
                    />
                </Div>

                {responseData?.SolicitarNumeroWhatsApp && (
                    responseData?.PuedeEditarNumeroWhatsApp ? (
                        <Div additionalClass="d-flex align-items-end">
                            <InputText
                                name="NumeroWhatsApp"
                                label="Número de WhatsApp"
                                value={numeroWhatsApp}
                                onChange={handleWhatsAppChange}
                                maxLength={9}
                                isRequired
                                placeholder="Ingresar 9 dígitos"
                            />
                            <button
                                type="button"
                                className="btn btn-primary generic-button-ficha ml-2 mb-1"
                                disabled={isSavingWhatsApp || !/^\d{9}$/.test(numeroWhatsApp)}
                                onClick={handleGuardarWhatsApp}>
                                {isSavingWhatsApp ? 'Guardando...' : 'Guardar'}
                            </button>
                        </Div>
                    ) : (
                        <Div>
                            <InputText
                                name="NumeroWhatsApp"
                                label="Número de WhatsApp"
                                value={responseData?.NumeroWhatsApp}
                                placeholder=""
                                isDisabled
                            />
                        </Div>
                    )
                )}

                <Div additionalClass="d-flex col-md-12">
                    <div className="button mb-2 mr-2">
                        <button className="btn btn-primary generic-button-ficha" onClick={(e) => {
                            e.preventDefault()
                            window.open(responseData?.SustentoSolicitudUrl, '_blank');
                        }}>Descargar Sustento
                        </button>
                    </div>
                    <div className="button mb-2">
                        <button className="btn btn-primary generic-button-ficha" onClick={(e) => {
                            e.preventDefault()
                            window.open(responseData?.CampanaBeneficioLineamientosUrl, '_blank');
                        }}>Descargar Lineamientos
                        </button>
                    </div>
                </Div>


                <TableBeneficiosToSolicitarSummary>
                    <table>
                        <thead>
                        <tr>
                            <th>Descripción</th>
                            <th>Cantidad</th>
                            <th>Precio Unitario</th>
                            <th>Sub. Total</th>
                        </tr>
                        </thead>
                        <tbody>

                        {responseData?.Items?.map(o => (
                            <tr key={o.IdBeneficioItem}>
                                <td>{o?.Descripcion}</td>
                                <td>{o?.Cantidad}</td>
                                <td>{o?.MontoText}</td>
                                <td>{o?.SubTotal}</td>
                            </tr>
                        ))}

                        </tbody>
                        <tfoot>
                        <tr className="total-row">
                            <td colSpan="3">Total</td>
                            <td>{responseData?.Total}</td>
                        </tr>
                        </tfoot>
                    </table>
                </TableBeneficiosToSolicitarSummary>
            </div>

            <div className="modal-footer justify-content-end">
                <div className="d-flex justify-content-center align-items-center" style={{gap: "10px"}}>
                    {isAdmin && responseData.PuedeAprobar &&
                        <button type='button' className='btn generic-button-buscador generic-button-hover-verde'
                                disabled={isSending}
                                onClick={handleApprove}
                        >
                            Aprobar
                        </button>
                    }
                    {isAdmin && responseData.PuedeRechazar &&
                        <button type='button' className='btn generic-button-buscador generic-button-hover-rojo'
                                disabled={isSending}
                                onClick={() => setModalEnabled({ isEnable: true, component: RechazarSolicitudBeneficio, data: { toggleMainModal:toggleModal, idSolicitudBeneficio: responseData?.IdSolicitudBeneficio } })}
                        >
                            Rechazar
                        </button>
                    }
                </div>
            </div>
        </ModalForm>
    );
}

export default VerDetalleSolicitudBeneficio;
